import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=56e17906&scoped=true&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxGroup.vue?vue&type=style&index=0&id=56e17906&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e17906",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
